export default "/images/001a03ba6d66bb94a12d4abf3e68f62d.avif";